module.exports = __webpack_public_path__ + "static/img/in.e6c85e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/in.png
// module id = 0aiu
// module chunks = 1 3